export function formatCompactCurrency(value, symbol = '') {
    if (value >= 1000000) {
      return `${symbol}${(value / 1000000).toFixed(value % 1000000 === 0 ? 0 : 1)}m`;
    }
    if (value >= 1000) {
      return `${symbol}${(value / 1000).toFixed(value % 1000 === 0 ? 0 : 1)}k`;
    }
    return `${symbol}${value}`;
  }
  